<template>
  <AGCard
    class="ag-indicador-rosca"
    :has-rounded-top="!noBorderRadius"
    :has-rounded-bottom="!noBorderRadius"
    :class="classes"
    @click="aoClicar"
  >
    <template v-if="!isFetching" #header>
      <div class="d-flex align-center justify-space-between w-100 mb-4">
        <slot v-if="$slots.title || title" name="title">
          <div v-html="title"></div>
        </slot>

        <v-spacer></v-spacer>

        <AGTooltip
          v-if="tooltip"
          large-tooltip-icon="mdi-information-outline"
          large-tooltip-title="Informação"
          :large-tooltip="true"
        >
          <template #largeTooltipContent>
            <slot v-if="$slots.tooltip || tooltip" name="tooltip">
              <div v-html="tooltip"></div>
            </slot>
          </template>

          <div class="d-flex align-center">
            <AGIcon icon="md:info" size="24px" />
          </div>
        </AGTooltip>
      </div>
    </template>

    <div v-if="!isFetching" class="ag-indicador-rosca__conteudo">
      <div class="d-flex align-self-end flex-column">
        <div class="ag-indicador-rosca__value">
          {{ value }}
        </div>

        <div v-if="hasCaption" class="ag-indicador-rosca__caption">
          {{ computedCaption }}
        </div>
      </div>

      <div v-if="hasGraphOptions" class="ag-indicador-rosca__grafico">
        <AGGraficoRosca :series="graphOptions.series" :options="computedGraphOptions" />
      </div>
    </div>

    <v-skeleton-loader v-else height="146px" type="heading, paragraph" />
  </AGCard>
</template>

<script>
import AGCard from '@/components/common/AGCard.vue';
import AGGraficoRosca from '@/components/common/AGGraficoRosca.vue';
import AGIcon from '@/components/common/AGIcon.vue';
import AgTooltipOld from '@/components/common/AGTooltipOld.vue';

export default {
  emits: ['click'],
  components: {
    AGGraficoRosca,
    AGCard,
    AGIcon,
    AGTooltip: AgTooltipOld,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isFetching: {
      type: Boolean,
      default: false,
    },
    caption: {
      type: String,
      default: '',
    },
    graphOptions: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      required: false,
    },
    tooltip: {
      type: String,
      default: null,
    },
    value: {
      type: Number,
      required: true,
    },
    noBorderRadius: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    hasGraphOptions() {
      return Object.keys(this.graphOptions).length > 0;
    },
    hasCaption() {
      return !!this.caption;
    },
    computedCaption() {
      return this.value !== 0 && this.value !== '0' ? this.caption : 'Nenhum dado encontrado para este indicador.';
    },
    classes() {
      return {
        'ag-indicador-rosca--active': this.active,
        'ag-indicador-rosca--clickable': this.clickable,
        'ag-indicador-rosca--disabled': this.disabled,
        'ag-indicador-rosca--fetching': this.isFetching,
      };
    },
    computedGraphOptions() {
      return {
        chart: {
          width: '110%',
        },
        plotOptions: {
          pie: {
            customScale: 1.1,
            donut: {
              size: '60%',
            },
          },
        },
        states: {
          hover: {
            filter: {
              type: 'none',
            },
          },
          active: {
            filter: {
              type: 'none',
            },
          },
        },
        legend: {
          show: false,
        },
        colors: this.graphOptions.colors,
      };
    },
  },

  methods: {
    aoClicar(e) {
      if (!this.clickable || this.disabled || this.isFetching) return;
      this.$emit('click', e);
    },
  },
};
</script>

<style scoped lang="scss">
.ag-indicador-rosca {
  max-width: 587px;

  &--clickable {
    cursor: pointer;
    &:hover {
      background-color: $brand-color-highlight-light;
    }
    &.ag-indicador-rosca--disabled {
      cursor: not-allowed;
    }
  }

  &--active {
    border-top-color: $brand-color-highlight-medium;
    border-top-width: $border-width-thick;
  }

  &--disabled {
    background-color: $neutral-color-low-medium;
    &:hover {
      background-color: $neutral-color-low-medium;
    }
    &.ag-indicador-rosca--active {
      border-top-color: $neutral-color-low-dark;
      border-top-width: 1px;
    }
  }

  &--fetching {
    background-color: $neutral-color-low-light;
    cursor: progress !important;
    &:hover {
      background-color: $neutral-color-low-light;
    }
  }

  .ag-indicador-rosca__conteudo {
    display: flex;
    justify-content: space-between;
    align-items: start;

    .ag-indicador-rosca__value {
      color: $neutral-color-high-medium;
      margin-top: $spacing-05;
      font-size: $font-size-xl;
      line-height: 1;
    }

    .ag-indicador-rosca__caption {
      color: $neutral-color-high-medium;
      margin-top: $spacing-05;
      font-size: $font-size-xs;
    }

    .ag-indicador-rosca__grafico {
      max-width: 100px;
      max-height: 100px;
    }
  }
}
</style>
